import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-zinc-900 border-t border-zinc-800" data-id="element-88">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-90">
          <div className="w-16 h-16 bg-zinc-800 rounded-full flex items-center justify-center mb-6" data-id="element-91">
            <ShieldCheck className="w-8 h-8 text-blue-500" data-id="element-92" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-93">
            Garantía simple de 7 días
          </h2>
          <p className="text-zinc-400 text-lg leading-relaxed text-balance" data-id="element-94">
            Tenés 7 días para revisar el contenido. Si sentís que el curso no te
            aporta claridad real para publicitar tu tienda de iPhones, podés
            solicitar la devolución.
          </p>
        </motion.div>
      </div>
    </section>;
}